import React, {useContext} from "react";
import {APanel, APanelBody} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {InvestigationDetailContext} from "contexts/InvestigationDetailContext";
import InvestigateGraphWrapper from "./InvestigationGraph/InvestigateGraphWrapper";
import InvestigationDetailToolbar from "./InvestigationGraph/InvestigationDetailToolbar/InvestigationDetailToolbar";
import css from "./InvestigateGraphPanel.module.scss";

// @todo Build Graph Loader as custom Skeleton
const InvestigateGraphPanel = ({className}) => {
  const {isFullscreen} = useContext(InvestigationDetailContext);

  return (
    <div
      className={classNames(css.investigationGraph, className, {
        [css.fullscreen]: isFullscreen,
        "pa-2": isFullscreen
      })}>
      <InvestigationDetailToolbar />
      <APanel>
        <APanelBody
          className={classNames("d-flex flex-column pa-0", {
            [css.graphPanelBodyFullscreen]: isFullscreen
          })}>
          <InvestigateGraphWrapper />
        </APanelBody>
      </APanel>
    </div>
  );
};

export default InvestigateGraphPanel;
